import TextField from '@mui/material/TextField';

export const inputStyle = {
  '& .MuiOutlinedInput-input': {
    height: "1em",
  },
}

const BaseInput = ({field, meta, props, children}) => {
  
  const {touched, error} = meta;
  const isInValid = !!(touched && error); //conversion was needed because it may return the error message instead of a bool 
  const {helperText, name, required=true, inputType="text", ...restOfProps} = props;
  // field => name, value, onChange
  
  return (
    <TextField
      {...restOfProps}
      {...field}
      required={required}
      error={isInValid}
      helperText={isInValid ? error : helperText}
      type={name?.toLowerCase().includes("password") ? "password" : inputType}
      variant="outlined"
      fullWidth
      sx={inputStyle}
    >
      {children}
    </TextField>
  );
};

export default BaseInput;